export const CURRENCY_CONFIG_COOKIE = 'bonhams_currency_config'
export const NOT_DEFINED_CURRENCY = 'NO_VALUE'
